export const BLOG_POSTS = [
  {
    slug: "spring-carp-tactics",
    title: "Spring Carp Tactics: Waking the Lake Up",
    category: "Carp Fishing Tips",
    excerpt: "As water temperatures climb, carp become mobile and hungry. Here's how to capitalise on the spring feeding spells.",
    image: "https://images.unsplash.com/photo-1778016740380-21c3277768f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    author: "Furn Team",
    date: "12 Mar 2026",
    read: "6 min",
    body: [
      "Spring is arguably the most exciting time of the year for the carp angler. After a long, cold winter the fish begin to move, feed and search for warmth in the upper layers of the water.",
      "Location is everything. Target the warmest areas of the lake first — north-facing banks that catch the sun, shallow bays and any snaggy areas where fish hold up. A pair of polarised glasses is worth its weight in gold at this time of year.",
      "Keep your baiting subtle. A few small pouches of boilies and some crushed particle can be more effective than a big bed of bait when the fish are still shaking off winter. Bright, high-attract pop ups fished over the top will pick off the mobile fish.",
      "Don't be afraid to stay mobile. If you haven't had signs of fish within a couple of hours, move. Spring carp reward the angler who hunts them down.",
    ],
  },
  {
    slug: "ronnie-rig-guide",
    title: "The Ronnie Rig: A Complete Step-by-Step Guide",
    category: "Rig Guides",
    excerpt: "The Ronnie rig is one of the most effective bottom-bait and pop-up presentations. Here's how to tie one properly.",
    image: "https://static.prod-images.emergentagent.com/jobs/3e95e53d-003f-48d3-97b6-5c37869a29ed/images/afada2c2aaf0f9317e367212703234920c25b4f671946667ab8033d4f4148d48.png",
    author: "Furn Team",
    date: "28 Feb 2026",
    read: "8 min",
    body: [
      "The Ronnie rig, sometimes called the spinner rig, has become a firm favourite among carp anglers for its incredible hooking potential and low-lying pop-up presentation.",
      "You'll need a size 6 curved-shank hook, a hook swivel, a mini ring swivel, shrink tube and a soft hooklink material. Start by mounting the hook swivel to the hook, then blob the shrink tube to set the angle.",
      "Balance your pop up carefully — the rig only works at its best when the hookbait is critically balanced so it flips and takes hold in the bottom lip.",
      "Fish it over a spread of matching freebies and you'll be into fish in no time.",
    ],
  },
  {
    slug: "choosing-first-boilie",
    title: "Bait Advice: Choosing Your First Boilie",
    category: "Bait Advice",
    excerpt: "Fishmeal, birdfood or milk protein? We break down the boilie categories to help you pick a winner.",
    image: "https://static.prod-images.emergentagent.com/jobs/3e95e53d-003f-48d3-97b6-5c37869a29ed/images/9577d2ec0f3250da2634d447a0c5923f7866b89750f2eca9e555abf9db075de9.png",
    author: "Furn Team",
    date: "15 Feb 2026",
    read: "5 min",
    body: [
      "Walk into any tackle shop and the sheer choice of boilies can be overwhelming. The good news is you don't need a science degree to pick a bait that catches.",
      "Fishmeal baits are packed with attraction and are brilliant in the warmer months when fish are feeding hard. Birdfood baits are softer, break down quickly and are a superb year-round option.",
      "Our advice? Pick a quality bait, have confidence in it, and use it consistently. Confidence catches carp.",
    ],
  },
  {
    slug: "session-report-linear",
    title: "Session Report: 48 Hours on a Southern Syndicate",
    category: "Session Reports",
    excerpt: "Three bites, two lost, one absolute unit on the bank. A rollercoaster overnighter in the margins.",
    image: "https://images.unsplash.com/photo-1570655371646-1108a3515435?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    author: "Furn Team",
    date: "02 Feb 2026",
    read: "7 min",
    body: [
      "Arriving at the lake on a mild, overcast morning, the signs were good. Fish were showing over the shallow plateau and I set up to intercept them.",
      "The first bite came just after dark — a screaming take that unfortunately came adrift after a hectic scrap. Heartbreaking, but part of the game.",
      "At first light the left rod was away and after a dogged fight a stunning common slid over the net cord. Moments like these are what it's all about.",
    ],
  },
];
